import { apiClient } from '@/shared/lib/axios';
import type { Town } from '@/types/admin-town';

export interface UpdateTownPayload {
  name: string;
  kana: string;
  postal_code1: string;
  postal_code2: string;
  search_name: string;
}

export interface TownApiResponse {
  success: boolean;
  message: string;
  data: Town;
}

export const getTown = async (siteType: string, id: number): Promise<{ data: Town }> => {
  const response = await apiClient.get<{ data: Town }>(`/admin/${siteType}/towns/${id}`);
  return response.data;
};

export const updateTown = async (
  siteType: string,
  id: number,
  data: UpdateTownPayload
): Promise<TownApiResponse> => {
  const response = await apiClient.put<TownApiResponse>(`/admin/${siteType}/towns/${id}`, data);
  return response.data;
};
